import { QuestionStateMachineData, QuestionState, QuestionAnswer } from '../data'

export class NotAnsweredState {
  public readonly name = 'not-answered'
  stateEvents: {
    onAnswerChanged: () => void
  }

  constructor(private data: QuestionStateMachineData) {
  }

  updateState(state: QuestionState) {
    this.data.state = state
  }
    
  updateAnswer(answer: QuestionAnswer) {
    this.data.answer = answer;
    this.stateEvents.onAnswerChanged();
  }
}
